import { render, staticRenderFns } from "./TopPecas.vue?vue&type=template&id=02347264&"
import script from "./TopPecas.vue?vue&type=script&lang=ts&"
export * from "./TopPecas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports